import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=01f125d4&scoped=true&lang=pug&"
import script from "./NoAccess.vue?vue&type=script&lang=js&"
export * from "./NoAccess.vue?vue&type=script&lang=js&"
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=01f125d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f125d4",
  null
  
)

component.options.__file = "NoAccess.vue"
export default component.exports